function interpolateFallback(fallback, values) {
    if (!values) return fallback;

    return Object.entries(values).reduce(
        (result, [name, value]) => result.replace(`{${name}}`, value),
        fallback
    );
}

export function translateWithFallback(
    translateFn,
    key,
    fallback,
    values = null
) {
    const interpolatedFallback = interpolateFallback(fallback, values);

    if (typeof translateFn !== 'function') return interpolatedFallback;

    const translated = values ? translateFn(key, values) : translateFn(key);

    return translated && translated !== key ? translated : interpolatedFallback;
}

export function translateWithDefault(
    translateFn,
    key,
    fallback,
    values = null
) {
    const interpolatedFallback = interpolateFallback(fallback, values);

    if (typeof translateFn !== 'function') return interpolatedFallback;

    const translated = translateFn(key, interpolatedFallback, values);

    return translated && translated !== key ? translated : interpolatedFallback;
}

export function formatEnumLabel(value) {
    return String(value || '')
        .split('_')
        .map((word) =>
            word ? word.charAt(0) + word.slice(1).toLowerCase() : ''
        )
        .join(' ');
}
